import { toast } from "react-toastify";
import { useEffect, useState, useRef } from "react";
import { Button, CircularProgress } from "@mui/material";
import ReactMarkdown from "react-markdown";
import Error from "../../Error";
import axios from "axios";

const Readme = ({ id, isAdmin }) => {
    const inputRef = useRef();
    const [file, setFile] = useState(null);
    const [fileFirst, setFileFirst] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editPage, setEditPage] = useState(true);
    const [isNoData, setIsNoData] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [saving, setSaving] = useState(false);
    const [deletePage, setDeletePage] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [viewPage, setViewPage] = useState(true);

    const getFile = () => {
        setLoading(true);
        setFile(null);
        setErrorMsg(false);
        axios(`${process.env.REACT_APP_URL}/api/idp/v2/api/${id}/readme`, {
            headers: {
                Authorization: sessionStorage.getItem("token"),
                responseType: "text",
            },
        })
            .then((res) => {
                if (!res.data) setIsNoData(true);
                setFileFirst(res.data);
                setFile(res.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setErrorMsg(true);
            });
    };

    const handleCreate = () => {
        setIsNoData(false);
        setEditPage(false);
        setViewPage(false);
        setTimeout(() => {
            inputRef.current?.focus();
        });
    };

    const onSubmit = () => {
        setEditPage(true);
        setSaving(true);
        axios
            .post(
                `${process.env.REACT_APP_URL}/api/idp/v2/api/${id}/readme`,
                { text: file },
                {
                    headers: { Authorization: sessionStorage.getItem("token") },
                }
            )
            .then((res) => {
                toast.success("Successfully saved!");
                getFile();
                setSaving(false);
                setViewPage(true);
            })
            .catch((err) => {
                toast.error("An error occurred!");
                setEditPage(false);
                setSaving(false);
            });
        setEditPage(true);
    };

    const handleDelete = () => {
        setDeletePage(true);
        setViewPage(false);
    };

    const handleEdit = () => {
        setEditPage(false);
        setDeletePage(false);
        setViewPage(false);
    };

    const deleteFile = () => {
        setDeleting(true);
        setErrorMsg(false);

        axios
            .delete(`${process.env.REACT_APP_URL}/api/idp/v2/api/${id}/readme`, {
                headers: { Authorization: sessionStorage.getItem("token"), responseType: "text" },
            })
            .then((res) => {
                setIsNoData(true);
                setDeleting(false);
                setDeletePage(false);
                setFile("");
                setViewPage(true);
            })
            .catch((err) => {
                setDeleting(false);
                setErrorMsg(true);
            });
    };

    useEffect(() => {
        getFile();
    }, []);

    return (
        <div>
            {isAdmin && (
                <div className="inline-flex rounded-md shadow-sm" role="group">
                    <button
                        onClick={() => handleCreate()}
                        disabled={file || !isNoData || deleting}
                        style={file || !isNoData || deleting ? { background: "#ddd" } : {}}
                        className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-l-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
                    >
                        <i className="fa-solid fa-folder-plus mr-2"></i>
                        Create
                    </button>
                    <button
                        onClick={handleEdit}
                        disabled={!editPage || !file || deleting || saving}
                        style={!editPage || !file || deleting || saving ? { background: "#ddd" } : {}}
                        className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
                    >
                        <i className="fa-solid fa-pen-to-square mr-2"></i>
                        Edit
                    </button>
                    <button
                        onClick={onSubmit}
                        disabled={editPage || !file || deleting || file === fileFirst}
                        style={editPage || !file || deleting || file === fileFirst ? { background: "#ddd" } : {}}
                        className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
                    >
                        {saving ? <CircularProgress size="0.9rem" className="mr-2" /> : <i className="fa-solid fa-floppy-disk mr-2"></i>}
                        Save
                    </button>
                    <button
                        onClick={handleDelete}
                        disabled={!editPage || !file || deleting || saving}
                        style={!editPage || !file || deleting || saving ? { background: "#ddd" } : {}}
                        className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-r-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
                    >
                        {deleting ? <CircularProgress size="0.9rem" className="mr-2" /> : <i className="fa-solid fa-floppy-disk mr-2"></i>}
                        Delete
                    </button>
                </div>
            )}

            {loading ? (
                <div className="my-14 py-10 text-center">
                    <CircularProgress />
                </div>
            ) : errorMsg ? (
                <Error msg="An error occurred white getting Readme file" />
            ) : isNoData ? (
                <div className="text-center my-14 py-14">
                    <i style={{ fontSize: "70px" }} className="fa-regular fa-folder-open"></i>
                    <p className="my-5 text-xl">README not found</p>
                </div>
            ) : viewPage ? (
                <div className="readme w-100 mt-5 mb-4 border rounded-md">
                    <ReactMarkdown className="p-5 h-full">{file}</ReactMarkdown>
                </div>
            ) : deletePage ? (
                <div className="py-10 w-fit">
                    Do you want to delete the readme?{" "}
                    <div className="mt-4">
                        <Button size="small" variant="contained" disabled={deleting} color="error" onClick={deleteFile}>
                            Delete
                        </Button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="readme w-100 mt-5 mb-4 border rounded-md">
                        <div className="grid grid-cols-1 lg:grid-cols-2">
                            <div className="lg:border-r">
                                <div className="bg-gray-50 border-0 border-b border-gray-200 text-gray-900 text-sm rounded-t-lg w-full p-2.5">
                                    <h4 style={{ fontSize: "20px" }}>Edit</h4>
                                </div>
                                <textarea
                                    ref={inputRef}
                                    disabled={editPage}
                                    cols={50}
                                    className="w-full h-full p-5 my-0"
                                    onChange={(e) => setFile(e.target.value)}
                                    value={file}
                                    onResize={false}
                                ></textarea>
                            </div>
                            <div>
                                <div className="bg-gray-50 border-0 border-b border-gray-200 text-gray-900 text-sm rounded-t-lg w-full p-2.5">
                                    <h4 style={{ fontSize: "20px" }}>Review</h4>
                                </div>
                                <ReactMarkdown className="p-5 h-full">{file}</ReactMarkdown>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Readme;
